export const SUPPORT_PHONE = '+78007070308'
export const SUPPORT_PHONE_FORMATTED = '8 800 707-03-08'
export const SUPPORT_EMAIL = 'feedback@poleinvest.ru'
